export default __webpack_public_path__ + "static/media/100_38809.6579e3ad.jpg";